export const formatCountdown = (timestamp: any) => {
    const d = String(Math.floor(timestamp / (24 * 3600 * 1000))).padStart(2, '0');
    const h = String(Math.floor((timestamp - d * (24 * 3600 * 1000)) / (3600 * 1000))).padStart(2, '0');
    const m = String(Math.floor((timestamp - d * (24 * 3600 * 1000) - h * (3600 * 1000)) / (60 * 1000))).padStart(2, '0');
    const s = String(Math.floor((timestamp - d * (24 * 3600 * 1000) - h * (3600 * 1000) - m * (60 * 1000)) / 1000)).padStart(2, '0');
    return {
        d,
        h,
        m,
        s,
    };
};
